<template>
  <v-container class="page">
    <section class="about-copy">
      <h1>About Supply Chain Research</h1>
      <p>
        Supply Chain Research is a focused search experience for academic literature
        across warehouse management, transportation, supply chain planning, order
        management, manufacturing operations, sustainability, and risk management.
      </p>
      <p>
        The research catalog indexes scholarly works, authors, sources, topics,
        institutions, and citations from the global academic record.
      </p>
    </section>
  </v-container>
</template>

<script setup>
import { useHead } from '@unhead/vue';

defineOptions({ name: 'AboutPage' });

useHead({ title: 'About' });
</script>

<style scoped>
.about-copy {
  max-width: 760px;
  margin: 96px auto;
}

h1 {
  font-size: 40px;
  font-weight: 650;
  line-height: 1.15;
  letter-spacing: 0;
  margin-bottom: 24px;
}

p {
  font-size: 17px;
  line-height: 1.7;
  color: #52525b;
  margin-bottom: 18px;
}
</style>
